import { render, staticRenderFns } from "./PetitionsList.vue?vue&type=template&id=51f1c50a&scoped=true&"
import script from "./PetitionsList.vue?vue&type=script&lang=ts&"
export * from "./PetitionsList.vue?vue&type=script&lang=ts&"
import style0 from "./PetitionsList.vue?vue&type=style&index=0&id=51f1c50a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f1c50a",
  null
  
)

export default component.exports